
import Celo from "../../../assets/outline/Celo.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CeloIcon({ className, dataTestid = "CeloIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Celo data-testid={dataTestid} className={classes} {...rest} />
  );
}
